import { useTranslation } from "react-i18next";
import { Modal } from "components/designV2/modal/modal";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import SwishIcon from "images/icons/svg/v2/swish.svg";
import {
  PayoutMethodButton,
  PayoutMethodDescription,
  PayoutMethodGroup,
  PayoutMethodIcon,
  PayoutMethodLabel,
  PayoutSwishIcon,
  PayoutSectionTitle,
} from "./tips.payoutModal.styled";

interface TipsPayoutModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onSelectBankTransfer: () => void;
  readonly onSelectSwish: () => void;
}

export const TipsPayoutModal = (
  props: TipsPayoutModalProps,
): JSX.Element | null => {
  const { isOpen, onClose, onSelectBankTransfer, onSelectSwish } = props;
  const { t } = useTranslation();

  return (
    <Modal
      label={t("Tips.PayOut")}
      size="small"
      isOpen={isOpen}
      onClose={onClose}
    >
      <PayoutSectionTitle>{t("Tips.ChoosePaymentMethod")}</PayoutSectionTitle>

      <PayoutMethodGroup>
        <PayoutMethodButton type="button" onClick={onSelectBankTransfer}>
          <PayoutMethodIcon>
            <CustomIcon name="v2/transfer" size="24px" color={ColorV2.Blue1} />
          </PayoutMethodIcon>
          <PayoutMethodLabel>{t("Tips.BankTransfer")}</PayoutMethodLabel>
          <CustomIcon
            name="v2/right-chevron"
            size="24px"
            color={ColorV2.White}
          />
        </PayoutMethodButton>
        <PayoutMethodDescription>
          {t("Tips.BankTransferDescription")}
        </PayoutMethodDescription>
      </PayoutMethodGroup>

      <PayoutMethodGroup>
        <PayoutMethodButton type="button" onClick={onSelectSwish}>
          <PayoutMethodIcon>
            <PayoutSwishIcon src={SwishIcon} alt="" aria-hidden="true" />
          </PayoutMethodIcon>
          <PayoutMethodLabel>{t("Tips.Swish")}</PayoutMethodLabel>
          <CustomIcon
            name="v2/right-chevron"
            size="24px"
            color={ColorV2.White}
          />
        </PayoutMethodButton>
        <PayoutMethodDescription>
          {t("Tips.SwishDescription")}
        </PayoutMethodDescription>
      </PayoutMethodGroup>
    </Modal>
  );
};
